/**
@description 设置路由路径
*/
import Product from './Product'
import ProductDetail from './ProductDetail'
export const productIntroductionRouting = [
  {
    path: 'product',
    component: Product,
    name: '借款咨询',
    indexRoute: {
      name: '社保公积金借款',
      catname: 'payPeriodLoan',
      component: ProductDetail
    },
    childRoutes: [{
      name: '社保公积金借款',
      path: 'payPeriodLoan',
      component: ProductDetail
    }, {
      name: '按揭借款',
      path: 'goodCreditLoan',
      component: ProductDetail
    }, {
      name: '互联网借款',
      path: 'entrepreneurLoan',
      component: ProductDetail
    },{
      name: '保单借款',
      path: 'policyLoan',
      component: ProductDetail
    },{
      name: '信用卡借款',
      path: 'creditCardLoan',
      component: ProductDetail
    },{
      name: '学历借款',
      path: 'educationLoan',
      component: ProductDetail
    }]
  }
]



// WEBPACK FOOTER //
// ./modules/productIntroduction/routing.js